import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';

export function idealistDaysFacet(i18n: I18nFn) {
  return {
    id: 'isIdealistDay',
    name: 'isIdealistDay',
    get title() {
      return i18n('Show only Idealist Days');
    },
    options: ['true', 'false'],
    optionTitles: {
      true: 'Yes',
      false: 'No',
    },
    type: 'boolean',
    sort: false,
  } as const satisfies SearchFacetData;
}
